import { ReactNode } from 'react'

import Box from '@totallymoney/ui/components/Box'

export const BackLink = ({ children }: { children: ReactNode }) => (
    <Box mt="space30" mb={['space10', 'space20']} gridColumn="1/13">
        {children}
    </Box>
)

export const PageHeading = ({ children }: { children: ReactNode }) => (
    <Box gridColumn="1/13" mb={['space30', 'space50']}>
        {children}
    </Box>
)

export const ItemWrapper = ({ children }: { children: ReactNode }) => (
    <Box
        gridColumn="1/13"
        display="grid"
        gridGap={['space30', 'space50']}
        mb="space50"
    >
        {children}
    </Box>
)

export const ItemDetails = ({ children }: { children: ReactNode }) => (
    <Box
        gridColumn={['1/13', '1/13', '1/9']}
        display="flex"
        flexDirection={['column', 'row']}
    >
        {children}
    </Box>
)

export const ItemImage = ({ children }: { children: ReactNode }) => (
    <Box
        maxWidth={['216px', '375px']}
        mr={[0, 'space50']}
        mb={['space30', 0]}
        display="flex"
        alignSelf={['center', 'flex-start']}
    >
        {children}
    </Box>
)

export const ItemContent = ({ children }: { children: ReactNode }) => (
    <Box display="flex" flexDirection="column" justifyContent="space-between">
        {children}
    </Box>
)

export const ItemButtons = ({ children }: { children: ReactNode }) => (
    <Box
        gridColumn={['1/13', '1/13', '9/13']}
        display="flex"
        alignItems={['flex-end', 'center']}
        justifyContent="center"
    >
        {children}
    </Box>
)
